import React, { Component, Fragment } from "react";
import { Map, TileLayer, Marker, withLeaflet } from "react-leaflet";
import { ReactLeafletSearch } from "react-leaflet-search";
import { cloneDeep } from "lodash";
import { Button, Col, Form, Input, Modal, Row, Select, Checkbox, message, Table } from "antd";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  MinusOutlined,
  MobileOutlined,
  PhoneOutlined,
  PlusOutlined,
  UserOutlined,
  DeleteOutlined
} from "@ant-design/icons";
import DatePicker from "react-modern-calendar-datepicker";
import moment from "moment-jalaali";
import { Constants } from "../scripts/settings";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import API from "../scripts/api";
import { getItemStatus, PriceFormat, SearchFormat } from "../scripts/helpers";

const ReactLeafletSearchComponent = withLeaflet(ReactLeafletSearch);


class ReceptionForm extends Component {
  constructor() {
    super();

    this.state = {
        selected: {},
      devices:[],
      selected_devices: [],
      users: [],
      products: [],
      items: [], 
      data: [],
      confirm_transfer_to_accepted: false,
      submitting: false,
      cities: [],
      items_count: 0,
      devices_count: 0,
      kit_items: []
    };

    this.formRef = React.createRef();
    this.mapRef = React.createRef();
  }

  showMap = (address) => {
    this.setState({ visibleMap: true, selectedAddress: address });

    setTimeout(() => {
      this.mapRef.current.handleDidMount(address);
    }, 0);
  };

  hideMap = () => {
    this.setState({ visibleMap: false });
  };

  handleChangeDate = (date, obj) => {
    const state = {};
    state[obj] = date;
    this.formRef.current.setFieldsValue(state);
  };



  handleSubmit = () => {
    this.formRef.current.validateFields().then((values) => {
      this.props.onSubmit(values);
    }).catch(() => {
        this.setState({ submitting: false });
    });
  };

  handleWillUnmount = () => {
    this.formRef.current.resetFields();

  };

  handleDidMount = async (data = {}) => {
    
    if(data.id){
        await this.getReception(data.id)
    }
    this.setState({
      editMode: !!data.id,
    });
    // await this.getSearchCities()

    
  };
  getReception = async(id) => {

    await API.reception.show(id).then((result) => {
        this.setState({selected : result.data})
      const cloneData = cloneDeep(result.data);
    //   this.formRef.current.setFieldsValue(cloneData);
      if(result.data.confirm_transfer_to_accepted){
        this.setState({confirm_transfer_to_accepted: "checked"})
      }
      if(result.data.transfer_to_repair_stage){
        this.setState({transfer_to_repair_stage: "checked"})
      }
      if(result.data.send_sms_to_customer){
        this.setState({send_sms_to_customer: "checked"})
      }
      this.setState({ user_type: result.data.user_type})

    });

    
}

  handleSearchUsers = (value) => {

    // if(!this.state.user_type){
    //     message.error("نوع کاربر را انتخاب کنید")
    //     return
    // }
    if (value) {
      // this.handleSearchTimeOut(value)
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        //search function
        API.representative.list( {q: SearchFormat(value)}).then((result) => {
            console.log(result )
          if (result.data && result.data.length) {
            console.log("into handleSearchUsers is done" )

            const users = result.data.map(o => {
              return {
                id: o.id,
                full_name: o.full_name,
                phone: o.phone,
                value: value,
                count: 1
              }
            });

            this.setState({users: users});
          } else {
            this.setState({users: []});
          }
        });

      }, 300);
    }
}


handleSearchKitItems = (value) => {
    if (value) {
      // this.handleSearchTimeOut(value)
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        //search function
        API.kit_items.search({q: SearchFormat(value), type: "accessory"}).then((result) => {
          if (result.data && result.data.length) {
            const kit_items = result.data.map(o => {
              return {
                id: o.id,
                name: o.name,
                value: value,
                count: 1
              }
            });

            this.setState({kit_items: kit_items});
          } else {
            this.setState({kit_items: []});
          }
        });

      }, 300);
    }
}



handleFilterSearchApi = (input, option) => {
    const value = SearchFormat(input);
    const split = value.split(' ');
    let valid = option.code.indexOf(value) >= 0;

    split.forEach(val => {
      valid = valid || option.code.indexOf(val) >= 0;
    });

    return valid;
}


handleSelectUser = (value, options, key) => {
    API.representative.show(value).then((result) => {
        this.formRef.current.setFieldValue('full_name', result.data?.full_name);
        this.formRef.current.setFieldValue('city_id', result.data?.city_id);
       
    })
}

getSearchCities = (params = {}) => {
        this.setState({ loading: true });
        API.city.list(params)

            .then((result) => {
                if (result.data) {
                    this.setState({
                        loading: false,
                        cities: result.data,
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
};

changeUserType = (value) => {
    this.setState({ user_type: value })
};

onChangeChecbox = (value, itemName) => {
  console.log(value.target.checked, itemName)
  // this.setState({itemName: value.target.checked})
  this.formRef.current.setFieldsValue({[itemName]: value.target.checked})
}
setDymicDataCount= (name, count) => {
    this.setState({[name] : count})
}
  render() {
    const { onCancel, submitting, visible } = this.props;
    const { editMode, devices, selected_devices, users, items, kit_items,cities,
        confirm_transfer_to_accepted, transfer_to_repair_stage, send_sms_to_customer, formRef,
     selected} = this.state;
const device_columns = [
        {
                    title: Resources.IMEI,
                    dataIndex: 'imei',
                }, 
                {
                    title: Resources.name,
                    dataIndex: 'name',
                }, 
                {
                    title: Resources.serial,
                    dataIndex: 'serial',
                }, 
                {
                    title: Resources.code,
                    dataIndex: 'otp',
                },
                {
                    title:  `${Resources.approximateTime}(${Resources.hour})`,
                    dataIndex: 'repair_time',
                },  
     ]

     const item_columns = [
        {
            title: Resources.name,
            dataIndex: 'name',
        },
        {
            title: Resources.status,
            dataIndex: 'status',
            render: val => getItemStatus(val)
        },
        {
            title: `${Resources.approximateTime}(${Resources.hour})`,
            dataIndex: 'repair_time',
        },
     ]

    return (
      <Fragment>
        <Modal
          title={ Resources.show}
          visible={visible}
          onOk={this.handleSubmit}
          onCancel={onCancel}
          okText={Resources.confirm}
          cancelText={Resources.cancel}
          okButtonProps={{ loading: submitting }}
          cancelButtonProps={{ disabled: submitting }}
          className="modal-users"
          width={1000}
        >
           <Form ref={this.formRef} layout="vertical" >

            <div className='set_middle_content'><span>{Resources.userInfo}</span></div>
            <Row gutter={24} >
                <Col xs={24} md={4}>
                     <Form.Item
                       
                        label={`${Resources.userType}`}
                    >
                        <span className="span-vals">
                            {(selected.user_type == "representative") ? Resources.representative : Resources.customer}
                        </span>

                </Form.Item>
                </Col>

                <Col xs={6}>
                    <Form.Item  label={Resources.fullName}  >
                    <span className="span-vals">
                            {selected.full_name}
                        </span>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Form.Item label={Resources.phone}>
                    <span className="span-vals">
                            {selected.phone}
                        </span>
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Form.Item  label={Resources.city}  >
                    <span className="span-vals">
                            {selected?.user?.city?.name ?? ""}
                        </span>
                    </Form.Item>
                </Col>
              
            </Row>

            <br />
            {/* <div className='set_middle_content m-3'><span>{Resources.devices}</span></div> */}
              { (selected && selected.devices && selected.devices.length) &&
                             <>
                             <div className='set_middle_content m-3'><span>{`${Resources.devices} (${selected.devices.length})`}</span></div>
                         <div className="ant-content">
                                     <Table
                                         columns={device_columns}
                                         dataSource={selected.devices}
                                         size="small"
                                         rowKey="id"
                                         scroll={{ x: 900 }}
                                     />
                             </div>
                             </>
                         }
           
                { (selected && selected.items && selected.items.length) &&
                           <>
                               <br />
                               <div className='set_middle_content m-3'><span>{`${Resources.items} (${selected.items.length})`}</span></div>
                               <div className="ant-content">
                                       <Table
                                           columns={item_columns}
                                           dataSource={selected.items}
                                           size="small"
                                           rowKey="id"
                                           scroll={{ x: 900 }}
                                       />
                               </div>
                           </>
                       }

                <Row gutter={24}>
                    <Col xs={24}>
                        <Form.Item label={Resources.description} style={{textAlign: "justify"}}  >
                           <span>{selected.description}</span>
                        </Form.Item>
                    </Col>
                </Row>
            
            </Form>
        </Modal>

      </Fragment>
    );
  }
}

export default ReceptionForm;
